"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const styled_system_1 = require("styled-system");
const Svg = styled_components_1.default.div `
  ${(0, styled_system_1.compose)(styled_system_1.space, styled_system_1.layout, styled_system_1.color)};
  flex: none;
`;
Svg.defaultProps = { as: 'svg' };
exports.default = Svg;
//# sourceMappingURL=Svg.js.map